import { defineStore } from 'pinia';

export const useMessageStore = defineStore('message', {
  state: () => ({
    message: '',
    type: '',
    visible: false,
    _timer: null,
  }),
  actions: {
    addMessage(msg, type = 'success', timeout = null) {
      this.message = msg;
      this.type = type;
      this.visible = true;
      if (this._timer) {
        clearTimeout(this._timer);
        this._timer = null;
      }
      if (timeout) {
        this._timer = setTimeout(() => {
          this.removeMessage();
          this._timer = null;
        }, timeout);
      }
    },
    removeMessage() {
      this.message = '';
      this.type = '';
      this.visible = false;
      if (this._timer) {
        clearTimeout(this._timer);
        this._timer = null;
      }
    },
  },
  persist: {storage: localStorage}, // store in localstorage
});
